export default "__VITE_ASSET__YAIy7TKJ__"